let logoutTimeoutId;

const logoutMinutes = 120;

const setupInactivityWatcher = ({ store, router, onLogout }) => {
  const resetTimer = () => {
    clearTimeout(logoutTimeoutId);

    const logoutMs = logoutMinutes * 60 * 1000;

    logoutTimeoutId = setTimeout(() => {
      try {
        store.commit('RESET_ALL');
        router.push('/');

        if (typeof onLogout === 'function') {
          onLogout();
        }
      } catch (err) {
        console.error('Error durante RESET_ALL:', err);
      }
    }, logoutMs);
  };

  ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
    window.addEventListener(event, resetTimer);
  });

  resetTimer();
};

export default setupInactivityWatcher;
